import React from 'react'

const StiInfections = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 pt-md-5 pt-4 pb-4 '>
            <div className='pt-md-4'>
                <div className='fs-ss-32-1 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    SEXUALLY TRANSMITTED INFECTIONS/DISEASES
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-3 pt-2'>
                <div className='fs-ss-20-1 text-montserrat fw-600 text-ss-black pe-md-0 pe-4' style={{ fontStyle:'italic'}}>
                    Affordable STI / STD Testing Service in Chicago, IL
                </div>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    At United Lab Care, we understand the importance of STI/STD testing in ensuring sexual health and overall well-being. Our STI testing service is designed to detect and diagnose sexually transmitted infections, allowing you to take control of your health.
                </div>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Sexually Transmitted Infections (STIs) and STDs pose significant risks to public health and can lead to severe complications if left untreated. It’s crucial to stay informed about the causes, symptoms, and importance of STI testing. Regular testing allows for early detection and timely treatment, preventing the spread of infections and protecting yourself and your partners.
                </div>
            </div>

            <div className='pb-2'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                We offer confidential and easily accessible STI testing services in Chicago. Our dedicated team is committed to providing high-quality care and accurate results. Everyone deserves access to reliable STI testing, regardless of their financial situation. We offer low-cost options to ensure affordability and promote responsible sexual health practices.
                </div>
            </div>
        </div>
    </div>
  )
}

export default StiInfections